// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import { Field } from 'redux-form'
import { LabeledInput, RadioGroup } from 'components/Form'
import Heading from './Heading'
import icon from 'images/path-search-coordination.png'

const comsearchProtectedOptions = [{
  label: 'Any',
  value: '',
}, {
  label: 'Yes',
  value: 'true',
}, {
  label: 'No',
  value: 'false',
}]

const wrapperClasses = (
  'path-db-search-section-coordination path-db-search-section display-flex flex-wrap-wrap'
)

const Coordination = ({ idRoot }) => (
  <ul className={wrapperClasses}>
    <li className={'width-100'}>
      <Heading
        heading={'Coordination & FCC Information'}
        iconPath={icon}
        idRoot={`${idRoot}coordination`} />
    </li>
    <li className={'path-db-search-input-column'}>
      <Field
        component={LabeledInput}
        id={`${idRoot}rcn-number`}
        label={'RCN'}
        name={'rcnNumber'} />
    </li>
    <li className={'path-db-search-input-column'}>
      <Field
        component={LabeledInput}
        id={`${idRoot}asr`}
        label={'ASR'}
        name={'asr'}
        placeholder={'ASR Number'} />
    </li>
    <li className={'path-db-search-input-column'}>
      <Field
        component={LabeledInput}
        id={`${idRoot}uls-file-number`}
        label={'FCC File Number'}
        name={'ulsFileNumber'}
        placeholder={'FCC File #'} />
    </li>
    <li className={'path-db-search-input-column'}>
      <Field
        component={LabeledInput}
        id={`${idRoot}bill-code`}
        label={'Comsearch Bill Code'}
        name={'billcode'}
        placeholder={'Bill Code'} />
    </li>
    <li className={'path-db-search-input-column'}>
      <Field
        component={LabeledInput}
        id={`${idRoot}job-code`}
        label={'Job Number'}
        name={'jobCode'} />
    </li>
    <li className={'path-db-search-input-column'}>
      <Field
        idRoot={`${idRoot}protected-`}
        className={'flat-radios'}
        component={RadioGroup}
        label={'Comsearch Protected?'}
        name={'protectFlag'}
        options={comsearchProtectedOptions} />
    </li>
  </ul>
)

Coordination.propTypes = {
  idRoot: string.isRequired,
}

export default Coordination
